/**
 * Whether the QR code should render. `paymentQRCode` is nullable server-side —
 * `generatePaymentQRCode` (apps/server/src/utils/payment.ts) returns `null` whenever the branch
 * has no VietQR bank account configured — and qrcode.react happily encodes the literal text
 * "null" into a scannable-looking (but fake) "scan to pay" code for `null`/`undefined`/`''`.
 * Pure so the guard is testable without mounting OrderDetails' heavy tree.
 */
export function canShowPaymentQr(paid: boolean, paymentQRCode: string | null | undefined): paymentQRCode is string {
  return !paid && Boolean(paymentQRCode);
}
